import React, { useState, useMemo } from "react";
import {
	Button,
	Icon,
	Modal,
	Header,
	Table,
	Segment,
	Checkbox,
	Label,
	Divider,
	Card,
	Image as Img,
	Dimmer,
	Loader,
	Confirm,
} from "semantic-ui-react";
import { Field, Formik, Form } from "formik";
import moment from "moment";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import servipay from "assets/image/servipay.png";
import sumup from "assets/image/sumup.png";
import cash from "assets/image/cash.jpg";
import { getFullName } from "utils/displayName";

const CasingPaymentModal = ({
	open,
	close,
	exportGeslab,
	patient,
	invoices,
	costsPatient = 0,
	center,
	t,
	addPayment,
	casing,
	casingPaymentCancel,
}) => {
	const [confirmCancelPaymentOpen, setConfirmCancelPaymentOpen] = useState(false);
	const [confirmCancelPaymentId, setConfirmCancelPaymentId] = useState(0);
	const [addFreeAmount, setAddFreeAmount] = useState(false);
	const [freeAmountValidated, setFreeAmountValidated] = useState(0);
	const [docToDisplay, setDocToDisplay] = useState(null);
	const [selectedFreeAmount, setSelectedFreeAmount] = useState(false);
	const [payments, setPayments] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [paymentOptionsModalLoading, setPaymentOptionsModalLoading] = useState(false);

	const stillInvoicesToPay = () => {
		if (invoices && invoices.length > 0) {
			return invoices?.some(
				(i) =>
					casing.payments &&
					(!casing.payments.some((p) => p.invoice_reference === i.reference) ||
						+i.amount.toFixed(2) >
							+casing.payments
								.filter((p) => p.invoice_reference === i.reference)
								.reduce((acc, p) => acc + p.price, 0)
								.toFixed(2))
			);
		} else return false;
	};

	const checkToggle = (payment) => {
		if (payments && payments.filter((p) => p.id === payment.id).length > 0) {
			let pList = payments.filter((p) => p.id !== payment.id);
			setPayments(pList);
		} else {
			var p = payments.slice();

			p.push(payment);
			setPayments(p);
		}
	};
	const overPayment = () => {
		if (casing && casing.payments && casing.payments.filter((p) => !p.invoice_reference).length > 0) {
			let result = casing.payments
				.filter((p) => !p.invoice_reference)
				.reduce((accum, p) => accum + p.price, 0)
				?.toFixed(2);
			if (+result > +costsPatient?.toFixed(2)) return +(result - +costsPatient?.toFixed(2)).toFixed(2);
		}
		return 0;
	};

	const amountInChargeSelected = () => {
		var sum = payments.reduce(
			(accum, p) =>
				accum +
				+p.amount.toFixed(2) -
				+casing.payments
					?.filter((pay) => pay.invoice_reference === p.reference)
					.reduce((accum, pay) => accum + +pay.price.toFixed(2), 0)
					.toFixed(2),
			0
		);
		return sum;
	};
	const currentAmountAlreadyPaid = (prescriptionId = null) => {
		if (
			casing &&
			casing.payments &&
			casing.payments.some((p) => !p.invoice_reference && (!prescriptionId || (!!prescriptionId && p.prescription === prescriptionId.toString())))
		) {
			let result = casing.payments
				?.filter((p) => !p.invoice_reference && (!prescriptionId || (!!prescriptionId && p.prescription === prescriptionId.toString())))
				.reduce((accum, p) => accum + p.price, 0)
				.toFixed(2);
			if (+result > +costsPatient?.toFixed(2)) return +costsPatient?.toFixed(2);
			else return +result;
		}
		return 0;
	};
	const amountToPayWithOtherPaymentsSelected = () => {
		if (+freeAmountValidated > 0) return +freeAmountValidated;
		let result = +(costsPatient?.toFixed(2) - currentAmountAlreadyPaid() + amountInChargeSelected() - +overPayment()).toFixed(2);
		return result;
	};

	const getPaymentsByRef = (ref, allRef = false) => {
		let res = getPaymentsBySource().filter((p) =>
			!ref && !allRef ? !p.invoice_reference : allRef ? !!p.invoice_reference : p.invoice_reference === ref
		);
		if (res.length > 0) return res.reduce((acc, r) => acc.concat(r.paiements), []);
		return [];
	};

	const getPaymentPartition = async () => {
		let freeAmountValidatedResult = freeAmountValidated;
		let partition = [];
		if (payments.length > 0) {
			for (let i = 0; i < payments.length; i++) {
				partition.push({
					prescription: null,
					cost:
						+payments[i].amount.toFixed(2) -
						+casing.payments
							.filter((p) => p.invoice_reference === payments[i].reference)
							.reduce((acc, p) => +acc + +p.price.toFixed(2), 0)
							.toFixed(2),
					invoice_reference: payments[i].reference,
				});
			}
		}
		if (freeAmountValidatedResult > 0) {
			const invoicesToPay = invoices
				.filter(
					(i) =>
						!partition.some((p) => p.invoice_reference === i.reference) &&
						+i.amount.toFixed(2) >
							+casing.payments
								.filter((p) => p.invoice_reference === i.reference)
								.reduce((acc, p) => acc + p.price, 0)
								.toFixed(2)
				)
				.slice()
				.sort((a, b) => moment(a.dossier_date) - moment(b.dossier_date))
				.map((i) => {
					return {
						...i,
						amount: i.amount - casing.payments.filter((p) => p.reference === i.reference).reduce((acc, p) => +(acc + p.price).toFixed(2), 0),
					};
				});
			if (invoicesToPay.filter((i) => i.amount > 0).length > 0) {
				if (freeAmountValidatedResult > 0) {
					for (let i = 0; i < invoicesToPay.length; i++) {
						if (invoicesToPay[i].amount < freeAmountValidatedResult) {
							freeAmountValidatedResult -= invoicesToPay[i].amount;
							partition.push({
								prescription: null,
								cost: invoicesToPay[i].amount,
								invoice_reference: invoicesToPay[i].reference,
							});
						} else {
							partition.push({
								prescription: null,
								cost: +freeAmountValidatedResult.toFixed(2),
								invoice_reference: invoicesToPay[i].reference,
							});
							freeAmountValidatedResult = 0;
							break;
						}
					}
				}
			}
		}
		//Par défaut, s'il reste quelque chose on le met sur la 1e référence trouvée
		if (freeAmountValidatedResult > 0) {
			partition.push({
				prescription: null,
				cost: +freeAmountValidatedResult.toFixed(2),
				invoice_reference: invoices[0]?.reference,
			});
			freeAmountValidatedResult = 0;
		}

		return partition;
	};

	const getPaymentsBySource = () => {
		let partielSum = [];
		casing.payments &&
			casing.payments.forEach((payment) => {
				if (
					partielSum.length > 0 &&
					partielSum.some((ps) => ps.invoice_reference === payment.invoice_reference && ps.voucher_code === payment.voucher_code)
				) {
					var ps = partielSum.find((ps) => ps.invoice_reference === payment.invoice_reference && ps.voucher_code === payment.voucher_code);
					ps.price += +payment.price.toFixed(2);
					ps.key = ps.key ? ps.key.toString().concat("-", payment.key) : payment.key;
					(ps.paiements && ps.paiements.length > 0 ? ps.paiements : []).push(payment);
				} else
					partielSum.push({
						key: payment.key,
						price: +payment.price.toFixed(2),
						voucher_code: payment.voucher_code,
						invoice_reference: payment.invoice_reference,
						paiements: [payment],
					});
			});
		return partielSum.slice().sort((a, b) => b.invoice_reference?.localeCompare(a.invoice_reference));
	};

	const b64toBlob = (b64Data, contentType) => {
		try {
			var byteCharacters = atob(b64Data);

			var byteArrays = [];

			for (let offset = 0; offset < byteCharacters.length; offset += 512) {
				var slice = byteCharacters.slice(offset, offset + 512),
					byteNumbers = new Array(slice.length);
				for (let i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}
				var byteArray = new Uint8Array(byteNumbers);

				byteArrays.push(byteArray);
			}

			var blob = new Blob(byteArrays, { type: contentType });
			return blob;
		} catch (e) {
			console.error("Error converting base64 to blob:", e);
			return null;
		}
	};

	return (
		<>
			<Modal size={!invoices || invoices.length === 0 ? "small" : "large"} open={open} closeOnEscape closeOnDimmerClick onClose={close}>
				<Modal.Header>Encaissement de factures restant à charge</Modal.Header>
				<Modal.Content>
					<Dimmer active={paymentOptionsModalLoading}>
						<Loader size="big">{t("folderManager.processing")}</Loader>
					</Dimmer>
					{(!invoices || invoices.length === 0) && <Modal.Content>Pas de facture à encaisser</Modal.Content>}
					{invoices && invoices.length > 0 && (
						<>
							<Header as="h5" attached="top" style={{ backgroundColor: "#009380", color: "white" }}>
								<div style={{ display: "flex", justifyContent: "space-between" }}>
									<span style={{ textTransform: "uppercase" }}>{invoices.length > 1 ? "Anciennes factures" : "Ancienne facture"}</span>
								</div>
							</Header>

							<Segment attached>
								<Table basic="very" celled>
									<Table.Header>
										<Table.Row>
											<Table.HeaderCell></Table.HeaderCell>
											<Table.HeaderCell>Montant</Table.HeaderCell>
											<Table.HeaderCell>Dossier</Table.HeaderCell>
											<Table.HeaderCell>Facture</Table.HeaderCell>
											<Table.HeaderCell>Rappel 1</Table.HeaderCell>
											<Table.HeaderCell>Rappel 2</Table.HeaderCell>
											<Table.HeaderCell>Rappel 3</Table.HeaderCell>
											<Table.HeaderCell>Paiements encaissés</Table.HeaderCell>
										</Table.Row>
									</Table.Header>
									<Table.Body>
										{invoices &&
											invoices.length > 0 &&
											invoices
												.slice()
												.sort((a, b) => moment(a.dossier_date) - moment(b.dossier_date))
												.map((i, index) => (
													<Table.Row key={`row-${index}`}>
														<Table.Cell
															textAlign="right"
															onClick={() => {
																if (freeAmountValidated > 0) setFreeAmountValidated(0);
																setSelectedFreeAmount(false);
															}}
														>
															{!selectedFreeAmount &&
																(!casing.payments ||
																	(casing.payments && casing.payments.filter((p) => p.invoice_reference === i.reference).length === 0)) && (
																	<Checkbox
																		style={{ padding: "4px", marginRight: "8px" }}
																		checked={payments && payments.some((p) => p.id === i.id)}
																		onChange={(e) => checkToggle(i, e)}
																	/>
																)}
															{casing.payments &&
																casing.payments
																	.filter((p) => p.invoice_reference === i.reference)
																	.reduce((acc, p) => acc + p.price, 0)
																	?.toFixed(2) === i.amount?.toFixed(2) && <Icon color="green" name="check" />}
															{casing.payments &&
																casing.payments.filter((p) => p.invoice_reference === i.reference).length > 0 &&
																+casing.payments
																	.filter((p) => p.invoice_reference === i.reference)
																	.reduce((acc, p) => acc + p.price, 0)
																	?.toFixed(2) < +i.amount?.toFixed(2) && (
																	<>
																		{" "}
																		<Icon color="orange" name="hand point right" />
																		{"Paiement partiel, reste à payer :"}
																		<br />
																	</>
																)}

															{casing.payments &&
																casing.payments.filter((p) => p.invoice_reference === i.reference).length > 0 &&
																+casing.payments
																	.filter((p) => p.invoice_reference === i.reference)
																	.reduce((acc, p) => acc + p.price, 0)
																	?.toFixed(2) > +i.amount?.toFixed(2) && (
																	<>
																		{" "}
																		<Icon color="green" name="hand point right" />
																		{"Trop perçu :"}
																		<br />
																	</>
																)}

															{casing.payments &&
																casing.payments
																	.filter((p) => p.invoice_reference === i.reference)
																	.reduce((acc, p) => acc + p.price, 0)
																	?.toFixed(2) !== i.amount?.toFixed(2) &&
																casing.payments.filter((p) => p.invoice_reference === i.reference).reduce((acc, p) => acc + p.price, 0) > 0 && (
																	<>
																		{!selectedFreeAmount &&
																			i.amount -
																				casing.payments.filter((p) => p.invoice_reference === i.reference).reduce((acc, p) => acc + p.price, 0) >
																				0 && (
																				<Checkbox
																					style={{ padding: "4px", marginRight: "40px" }}
																					checked={payments && payments.some((p) => p.id === i.id)}
																					onChange={(e) => checkToggle(i, e)}
																				/>
																			)}

																		{`${Math.abs(
																			i.amount -
																				casing.payments.filter((p) => p.invoice_reference === i.reference).reduce((acc, p) => acc + p.price, 0)
																		).toFixed(2)} €`}
																	</>
																)}
														</Table.Cell>
														<Table.Cell>{i.amount?.toFixed(2)} €</Table.Cell>
														<Table.Cell>
															{i.dossier_date && moment(i.dossier_date).format("DD/MM/YYYY")}
															<br />
															<span style={{ fontSize: "0.8rem", marginLeft: "4px" }}>{i.reference}</span>
														</Table.Cell>
														<Table.Cell>
															{i.invoice_date && moment(i.invoice_date).format("DD/MM/YYYY")}
															{i.last_invoice_pdf && (
																<Button
																	style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		setDocToDisplay(i.last_invoice_pdf);
																		setOpenModal(true);
																	}}
																>
																	<Icon name="file pdf" style={{ margin: 0 }} />
																</Button>
															)}
															{!i.reminder2_date && !i.reminder3_date && !i.reminder1_date && i.pdf && (
																<Button
																	style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		setDocToDisplay(i.pdf);
																		setOpenModal(true);
																	}}
																>
																	<Icon name="file pdf" style={{ margin: 0 }} />
																</Button>
															)}
														</Table.Cell>
														<Table.Cell>
															{i.reminder1_date && moment(i.reminder1_date).format("DD/MM/YYYY")}
															{!i.reminder2_date && !i.reminder3_date && i.reminder1_date && i.pdf && (
																<Button
																	style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		setDocToDisplay(i.pdf);
																		setOpenModal(true);
																	}}
																>
																	<Icon name="file pdf" style={{ margin: 0 }} />
																</Button>
															)}
														</Table.Cell>
														<Table.Cell>
															{i.reminder2_date && moment(i.reminder2_date).format("DD/MM/YYYY")}
															{i.reminder2_date && !i.reminder3_date && i.pdf && (
																<Button
																	style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		setDocToDisplay(i.pdf);
																		setOpenModal(true);
																	}}
																>
																	<Icon name="file pdf" style={{ margin: 0 }} />
																</Button>
															)}
														</Table.Cell>
														<Table.Cell>
															{i.reminder3_date && moment(i.reminder3_date).format("DD/MM/YYYY")}
															{i.reminder3_date && i.pdf && (
																<Button
																	style={{ margin: 0, padding: "3px", marginLeft: "4px" }}
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		setDocToDisplay(i.pdf);
																		setOpenModal(true);
																	}}
																>
																	<Icon name="file pdf" style={{ margin: 0 }} />
																</Button>
															)}
														</Table.Cell>
														<Table.Cell>
															{getPaymentsByRef(i.reference)?.map((p, index) => (
																<PaiementLabel
																	key={`${i.reference}-${index}`}
																	p={p}
																	done={false}
																	t={t}
																	setConfirmCancelPaymentOpen={setConfirmCancelPaymentOpen}
																	setConfirmCancelPaymentId={setConfirmCancelPaymentId}
																/>
															))}
														</Table.Cell>
													</Table.Row>
												))}
									</Table.Body>
								</Table>
							</Segment>

							{stillInvoicesToPay() && (
								<Header as="h5" attached="top" style={{ backgroundColor: "#009380", color: "white" }}>
									<div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", width: "100%" }}>
										<span style={{ textTransform: "uppercase" }}>Encaissement </span>
										{!selectedFreeAmount && (
											<Button
												onClick={(e) => {
													e.preventDefault();
													if (freeAmountValidated > 0) setFreeAmountValidated(0);
													setSelectedFreeAmount(!selectedFreeAmount);
													setAddFreeAmount(!selectedFreeAmount);
													setPayments([]);
												}}
											>
												Encaisser un montant libre
											</Button>
										)}
										{selectedFreeAmount && (
											<Formik
												initialValues={{
													freeAmountForm: "",
												}}
												onSubmit={(values) => {
													if (values.freeAmountForm === "") return;
													const amount = +values.freeAmountForm.toString()?.replace(",", ".");
													setAddFreeAmount(false);
													setFreeAmountValidated(amount);
												}}
											>
												{({ setFieldValue, values }) => {
													return (
														<Form>
															{!!selectedFreeAmount && (
																<div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
																	<>
																		{addFreeAmount && (
																			<div
																				style={{
																					minWidth: "100px",
																					display: "flex",
																					alignItems: "baseline",
																					justifyContent: "center",
																				}}
																			>
																				<div style={{ width: "100px", minWidth: "100px", fontSize: "0.8em" }}>
																					<Field
																						type="text"
																						name="freeAmountForm"
																						placeholder="Montant libre"
																						component={CustomInputTextComponent}
																						autoFocus
																						autoComplete="off"
																					/>
																				</div>
																				<Icon
																					name="check"
																					onClick={() => {
																						if (values.freeAmountForm) setAddFreeAmount(false);
																						setFreeAmountValidated(+values.freeAmountForm.toString()?.replace(",", "."));
																					}}
																					style={{ cursor: "pointer", fontSize: "1.2em", marginLeft: "10px" }}
																				/>
																			</div>
																		)}
																	</>
																</div>
															)}
														</Form>
													);
												}}
											</Formik>
										)}
									</div>
								</Header>
							)}
							{(freeAmountValidated > 0 || +amountToPayWithOtherPaymentsSelected().toFixed(2) > 0 || (+overPayment() > 0 && payments.length > 0)) && (
								<Segment attached>
									<>
										{freeAmountValidated > 0 && (
											<div style={{ display: "flex", alignItems: "baseline" }}>
												<>
													<Label color="orange" style={{ display: "flex", flexDirection: "row", justifyContent: "center", height: "26px" }}>
														{freeAmountValidated && +freeAmountValidated > 0 ? (+freeAmountValidated).toFixed(2) : 0} €
														{!!freeAmountValidated && +freeAmountValidated > 0 && (
															<Icon
																name="delete"
																onClick={() => {
																	setFreeAmountValidated(0);
																	setSelectedFreeAmount(false);
																}}
															/>
														)}
														<Label.Detail
															as="a"
															onClick={() => {
																//setFieldValue("freeAmountForm", +freeAmountValidated > 0 ? freeAmountValidated : "");
																setAddFreeAmount(true);
															}}
														>
															Modifier
														</Label.Detail>
													</Label>
													<> - Montant libre </>
												</>
											</div>
										)}
										{+overPayment() > 0 && payments.length > 0 && (
											<div>
												<Label color="green">{+overPayment()} €</Label> - Trop perçu{" "}
											</div>
										)}
										{+amountToPayWithOtherPaymentsSelected().toFixed(2) > 0 && (
											<div>
												<Label color="black">{amountToPayWithOtherPaymentsSelected().toFixed(2)} €</Label> -{" "}
												{t("folderManager.AmountToBeCollectedAll")}{" "}
											</div>
										)}
									</>

									{amountToPayWithOtherPaymentsSelected() > 0 && (
										<>
											<Divider />
											<Card.Group itemsPerRow={3}>
												{center?.servipayAvailable && (
													<Card>
														<Card.Content>
															<Img floated="right" size="mini" src={servipay} />
															<Card.Header>Servipay</Card.Header>
														</Card.Content>
														<Card.Content extra>
															<Button
																compact
																onClick={async (e) => {
																	if (e !== undefined) e.preventDefault();
																	setPaymentOptionsModalLoading(true);
																	addPayment({
																		type: "servipay",
																		amount: amountToPayWithOtherPaymentsSelected().toFixed(2),
																		isCasing: true,
																		partition: await getPaymentPartition(),
																		externalId: patient.id,
																		patient_name: getFullName(patient),
																		center_id: center?.id,
																	}).then((r) => {
																		if (freeAmountValidated > 0) setFreeAmountValidated(0);
																		setSelectedFreeAmount(false);
																		setPayments([]);
																		setPaymentOptionsModalLoading(false);
																	});
																}}
															>
																{t("folderManager.confirmServipay", { amountToPay: amountToPayWithOtherPaymentsSelected().toFixed(2) })}
															</Button>
														</Card.Content>
													</Card>
												)}
												{center?.cashAvailable && (
													<Card>
														<Card.Content>
															<Img src={cash} floated="right" size="mini" />
															<Card.Header>{t("folderManager.cash")}</Card.Header>
														</Card.Content>
														<Card.Content extra>
															<Button
																compact
																onClick={async (e) => {
																	if (e !== undefined) e.preventDefault();
																	setPaymentOptionsModalLoading(true);

																	addPayment({
																		type: "cash",
																		amount: amountToPayWithOtherPaymentsSelected().toFixed(2),
																		isCasing: true,
																		partition: await getPaymentPartition(),
																		externalId: patient.id,
																		patient_name: getFullName(patient),
																		center_id: center?.id,
																	}).then(() => {
																		if (freeAmountValidated > 0) setFreeAmountValidated(0);
																		setSelectedFreeAmount(false);
																		setPaymentOptionsModalLoading(false);
																		setPayments([]);
																	});
																}}
															>
																{t("folderManager.confirmCash", { amountToPay: amountToPayWithOtherPaymentsSelected().toFixed(2) })}
															</Button>
														</Card.Content>
													</Card>
												)}
												{center?.sumupAvailable && (
													<Card>
														<Card.Content>
															<Img src={sumup} floated="right" size="mini" />
															<Card.Header>Sumup</Card.Header>
														</Card.Content>
														<Card.Content extra>
															<Button
																compact
																onClick={async (e) => {
																	if (e !== undefined) e.preventDefault();
																	setPaymentOptionsModalLoading(true);

																	addPayment({
																		type: "sumup",
																		amount: amountToPayWithOtherPaymentsSelected().toFixed(2),
																		isCasing: true,
																		partition: await getPaymentPartition(),
																		externalId: patient.id,
																		patient_name: getFullName(patient),
																		center_id: center?.id,
																	}).then(() => {
																		if (freeAmountValidated > 0) setFreeAmountValidated(0);
																		setSelectedFreeAmount(false);
																		setPaymentOptionsModalLoading(false);
																		setPayments([]);
																	});
																}}
															>
																{t("folderManager.confirmSumup", { amountToPay: amountToPayWithOtherPaymentsSelected().toFixed(2) })}
															</Button>
														</Card.Content>
													</Card>
												)}
											</Card.Group>
										</>
									)}
								</Segment>
							)}
						</>
					)}
				</Modal.Content>
				<Modal.Actions>
					<Confirm
						open={confirmCancelPaymentOpen}
						content={t("folderManager.cancelPayment")}
						cancelButton={t("folderManager.no")}
						confirmButton={t("folderManager.yes")}
						onCancel={(e) => {
							if (e !== undefined) e.preventDefault();
							setConfirmCancelPaymentOpen(false);
							setConfirmCancelPaymentId(0);
						}}
						onConfirm={(e) => {
							if (e !== undefined) e.preventDefault();
							casingPaymentCancel(casing.id, confirmCancelPaymentId);
							setConfirmCancelPaymentOpen(false);
							setConfirmCancelPaymentId(0);
						}}
					/>
					{(!invoices || invoices.length === 0) && <Button onClick={close}>Fermer</Button>}
					{invoices?.length > 0 && (
						<Button
							onClick={async () => {
								close();
							}}
						>
							{casing.payments && casing.payments.length > 0 ? "Annuler le.s paiement.s" : "Fermer"}
						</Button>
					)}
					{invoices?.length > 0 && (
						<Button
							onClick={async () => {
								await exportGeslab(casing.id);
							}}
							primary
							disabled={!casing.payments || casing.payments.length === 0}
						>
							Valider
						</Button>
					)}
				</Modal.Actions>
			</Modal>
			<Modal
				open={openModal}
				size="large"
				closeOnEscape
				closeOnDimmerClick
				onClose={() => {
					setOpenModal(false);
					setDocToDisplay(null);
				}}
			>
				<Modal.Header>Document en attente de paiement</Modal.Header>
				<Modal.Content style={{ maxHeight: "75vh" }}>
					<iframe
						id="fraDisabled"
						//Prevent download
						src={useMemo(() => URL.createObjectURL(b64toBlob(docToDisplay, "application/pdf")) + "#toolbar=0", [docToDisplay])}
						title={"Facture en attente"}
						name={"Facture en attente"}
						style={{ width: "100%", height: "73vh" }}
					></iframe>
				</Modal.Content>
				<Modal.Actions>
					<Button
						content="Fermer"
						onClick={() => {
							setOpenModal(false);
							setDocToDisplay(null);
						}}
					/>
				</Modal.Actions>
			</Modal>
		</>
	);
};

const PaiementLabel = ({ keyId, p, t, done, setConfirmCancelPaymentOpen, setConfirmCancelPaymentId }) => {
	return (
		<Label key={`paiement-${keyId}`}>
			{p.price?.toFixed(2)} €
			<Label.Detail>
				{p.source === "toBill"
					? t("folderManager.toBill")
					: p.source === "stripe"
					? t("folderManager.stripe")
					: p.source === "voucher"
					? t("folderManager.voucher", { voucherCode: p.voucher_code })
					: p.source === "servipay"
					? t("folderManager.servipay")
					: p.source === "especes"
					? t("folderManager.cash")
					: p.source}
			</Label.Detail>
			{!done && (
				<Icon
					onClick={() => {
						setConfirmCancelPaymentOpen(true);
						setConfirmCancelPaymentId(p.id);
					}}
					name="delete"
				/>
			)}
		</Label>
	);
};

export default CasingPaymentModal;
